import Reflux from 'reflux';
import SteelCompass from 'services/SteelCompass';
import { MediaLibraryActions, AppActions } from 'actions';

const MediaLibraryStore = Reflux.createStore({
  listenables: [MediaLibraryActions],
  data: {
    grid: false,
    list: [],
    detail: {},
    breadcrumbs: [],
    saving: false,
    loading: true,
    selected: null,
    filter: {},
    sort: {}
  },
  serialize() {
    localStorage.setItem(
      'mediaLibrary',
      JSON.stringify({
        filter: this.data.filter,
        sort: this.data.sort,
        grid: this.data.grid
      })
    );
  },
  onDelete(ids) {
    return SteelCompass.call('file', 'update', { id: ids, hide: true }, () => {
      MediaLibraryActions.deleteComplete(ids);
    });
  },
  onDeleteComplete(ids) {
    this.data.list.forEach(file => {
      if (typeof ids === 'object') {
        if (ids.indexOf[file.id] > -1) {
          file.deleted = true;
        }
      } else {
        if (file.id === ids) {
          file.deleted = true;
        }
      }
    });
    this.trigger(this.data);
  },
  onGetFileInfoComplete(data) {
    this.data.selected = data;
    this.data.loading = false;
    this.trigger(this.data);
  },
  onGetFileInfo(id) {
    this.data.loading = true;
    return SteelCompass.request('file', 'getFileInfo', { id }).then(
      data => {
        if (data) {
          MediaLibraryActions.getFileInfoComplete((data[0] && data[0]) || null);
        } else {
          MediaLibraryActions.genericError();
        }
      },
      error => {
        MediaLibraryActions.genericError(error);
      }
    );
  },
  clearSelected() {
    this.data.selected = null;
    this.trigger(this.data);
  },
  getFilter() {
    return this.data.filter;
  },
  onResetFilter() {
    this.data.filter = {};
    this.trigger(this.data);
    this.serialize();
  },
  onSetFilter(filter) {
    Object.assign(this.data.filter, filter);
    this.trigger(this.data);
    this.serialize();
  },
  onResetSort() {
    this.data.sort = {};
    this.trigger(this.data);
    this.serialize();
  },
  onSetSort(sort) {
    Object.assign(this.data.sort, sort);
    this.trigger(this.data);
    this.serialize();
  },
  moveFiles(files) {
    const { breadcrumbs } = this.data;
    const currentDir =
      (breadcrumbs && breadcrumbs.length > 0 && breadcrumbs[0].id) || 0;
    const promises = files.map(file => {
      return SteelCompass.request('file', 'move', {
        id: file.file.id,
        directoryId: currentDir
      });
    });
    Promise.all(promises).then(
      values => {
        MediaLibraryActions.listDirectory(currentDir);
      },
      error => {
        this.data = {
          ...this.data,
          loading: false
        };
        this.trigger(this.data);
        AppActions.genericError(error);
      }
    );
  },
  getInitialState() {
    this.data = {
      ...this.data,
      ...JSON.parse(localStorage.getItem('mediaLibrary'))
    };
    return this.data;
  },
  find() {
    return this.listDirectory();
  },
  createDirectory(parentDirectoryId, name) {
    return SteelCompass.request('file', 'createDirectory', {
      directoryId: parentDirectoryId,
      name
    }).then(
      () => {
        MediaLibraryActions.listDirectory(parentDirectoryId);
      },
      error => {
        this.data = {
          ...this.data,
          loading: false
        };
        this.trigger(this.data);
        AppActions.genericError(error);
      }
    );
  },
  listDirectory(dirId = 0) {
    const directoryId = parseInt(dirId, 10);
    this.trigger(this.data);
    return SteelCompass.request('file', 'listDirectory', { directoryId }).then(
      response => {
        MediaLibraryActions.findComplete(response);
      },
      error => {
        this.data = {
          ...this.data,
          loading: false
        };
        this.trigger(this.data);
        AppActions.genericError(error);
      }
    );
  },
  toggleMode() {
    this.data = {
      ...this.data,
      grid: !this.data.grid
    };
    this.trigger(this.data);
    this.serialize();
  },
  refresh() {
    return SteelCompass.request('file', 'find', {}).then(
      response => {
        MediaLibraryActions.findComplete(response);
      },
      error => {
        this.data = {
          ...this.data,
          loading: false
        };
        this.trigger(this.data);
        AppActions.genericError(error);
      }
    );
  },
  findComplete(response) {
    const { files, breadcrumbs } = response;
    this.data = {
      ...this.data,
      list: files,
      breadcrumbs,
      loading: false
    };
    this.trigger(this.data);
  }
});

export default MediaLibraryStore;



// WEBPACK FOOTER //
// ./src/js/stores/MediaLibrary.js